const SummaryFormatterStyle = () => ({
    balance: { width: '100%' },
    icon: { cursor: 'default' },
    date: { width: '100%' },
    ellipsis: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
});

export default SummaryFormatterStyle;
